import * as types from './types';

export const setVisible = ({ commit }, isVisible) => {
  document.body.className = isVisible ? 'c-modal-open' : '';
  commit(types.SET_VISIBLE, isVisible);
};

export const toggleCategory = ({ commit }, category) => {
  commit(types.TOGGLE_CATEGORY, category);
};

export const resetClassIndex = ({ commit, dispatch }) => {
  commit(types.CLOSE_CATEGORIES);
  dispatch('index/fetchCategories', null, { root: true });
};



// WEBPACK FOOTER //
// ./src/screens/Class/ClassSidebar/store/actions.js